import React from "react";

import {
  View,
  StyleSheet,
  Platform,
} from "react-native";

import ChordDiagram from "./ChordDiagram";
import SankeyChart from "./SankeyChart";

export default class FlowChart extends React.Component {
  constructor(props) {
    super(props);
    this.controller = props.controller;
  }

  render() {
    const width = this.props.width;
    const height = this.props.height;
    const data = this.props.data;
    const hourly_data = this.props.hourly_data;

    return (
        <View
          style={{
            marginTop: 24,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ChordDiagram
                width={width}
                height={height}
                data={data}
          />
          {/*<SankeyChart
                width={width}
                height={height/2}
                data={hourly_data}
          */}
        </View>
    );
  }
}